import { render, staticRenderFns } from "./TheHot.vue?vue&type=template&id=27f8d8fb&scoped=true"
import script from "./TheHot.vue?vue&type=script&lang=js"
export * from "./TheHot.vue?vue&type=script&lang=js"
import style0 from "./TheHot.vue?vue&type=style&index=0&id=27f8d8fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f8d8fb",
  null
  
)

export default component.exports